import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "antd/dist/reset.css";

import App from "./App";
import { ConfigProvider } from "antd";
import { MessageProvider } from "./components/MessageProvider";
import { initTheme } from "./styles/theme";

// Initialize theme engine: inject CSS variables into :root
const THEME = initTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: THEME.primary,
        borderRadius: THEME.antd.borderRadius ?? 8,
        fontFamily: THEME.antd.fontFamily || "Inter, sans-serif",
        colorSuccess: THEME.antd.colorSuccess,
        colorError: THEME.antd.colorError,
        colorWarning: THEME.antd.colorWarning,
        colorInfo: THEME.antd.colorInfo,
      },
    }}
  >
    <MessageProvider>
      <App />
    </MessageProvider>
  </ConfigProvider>
);
